export const getDeltaAnnexInitialDataURL = () => {
  return `/customer/delta-annexure/initial/`;
};

export const searchDeltaAnnexuresDataURL = (page) => {
  return `/customer/delta-annexure/search/?page=${page}`;
};

export const commentDeltaAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/comment/`;
};

export const saveDeltaBillDetailsURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/save_bill_details/`;
};

export const printDeltaAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/?print=true`;
};

export const viewRegularisedAnnexureURL = (annexureId) => {
  return `/customer/delta-annexure/${annexureId}/`;
};
